import { render, staticRenderFns } from "./ProposalsProvider.vue?vue&type=template&id=03fcaac2&"
import script from "./ProposalsProvider.vue?vue&type=script&lang=js&"
export * from "./ProposalsProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports